// extracted by mini-css-extract-plugin
module.exports = {"information":"styles_information__3DftP"};